import * as ng from 'angular';
import { ArchiSmallServices } from '../../services/archismall.service';

export class AddPersonalFiles2Controller implements ng.IController {

    static $inject: string[] = [
        '$rootScope',
        '$uibModalInstance',
        '$sce',
        'user',
        'ArchiSmallServices',
        '$scope'
    ];

    private fiscalCodeFile: any;
    private fiscalCodeFileId: any;
    private fiscalCodeFilePath: any;
    private icon_fiscal_code: any;
    private delete_fiscal_code: any;
    private changedFieldFiscal: any;
    private businessProfileFile: any;
    private businessProfileFileId: any;
    private businessProfileFilePath: any;
    private icon_business_profile: any;
    private delete_business_profile_file: any;
    private changedFieldBusinessProfile: any;
    private identityCardFile: any;
    private identityCardFileId: any;
    private identityCardFilePath: any;
    private icon_id_card: any;
    private delete_id_card_file: any;
    private changedFieldIdentity: any;
    private identityCardFileBefore: any;
    private fiscalCodeFileBefore: any;
    private businessProfileFileBefore: any;
    private changedSuccess: any;
    private identityCardFileRequiredError: any;

    constructor(
        private $rootScope: any,
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        private $sce: any,
        private user: any,
        private ArchiSmallServices: ArchiSmallServices,
        private $scope: any
    ) {
        let vm = this;
        vm.user = user;

        this.init();

        $scope.uploadFileOnGoogleStorageCallback = (dropzoneId, res, filename) => {
            let icon = '';
            let delete_icon = '';
            let extension = filename.split('.').pop().toLowerCase();

            delete_icon = '<a ng-click=\'vm.deleteFile($event)\'><i class=\'fa fa-trash-o fa-2x delete-icon\'></i></a>';
            switch (extension) {
                case 'pdf':
                    icon = $sce.trustAsHtml('<i class=\'fa fa-file-pdf-o fa-2x\'></i>');
                    break;
                case 'jpg':
                case 'png':
                    icon = $sce.trustAsHtml('<i class=\'fa fa-file-image-o fa-2x\'></i>');
                    break;
                default:
                    icon = $sce.trustAsHtml('<i class=\'fa fa-file-o fa-2x\'></i>');
            }

            if (dropzoneId === 'dropzone-fiscal-code') {
                vm.user.organizationData.contactPerson.fiscalCodeFile = filename;
                vm.user.organizationData.contactPerson.fiscalCodeFileId = res.id.split('/')[0] + '/' + res.name;
                vm.fiscalCodeFile = filename;
                vm.fiscalCodeFileId = res.id;
                vm.fiscalCodeFilePath = res.name;
                vm.icon_fiscal_code = icon;
                vm.delete_fiscal_code = delete_icon;
                vm.changedFieldFiscal = true;
            } else if (dropzoneId === 'dropzone-business-profile') {
                vm.user.organizationData.contactPerson.businessProfileFile = filename;
                vm.user.organizationData.contactPerson.businessProfileFileId = res.id.split('/')[0] + '/' + res.name;
                vm.businessProfileFile = filename;
                vm.businessProfileFileId = res.id;
                vm.businessProfileFilePath = res.name;
                vm.icon_business_profile = icon;
                vm.delete_business_profile_file = delete_icon;
                vm.changedFieldBusinessProfile = true;
            } else {
                vm.user.organizationData.contactPerson.identityCardFile = filename;
                vm.user.organizationData.contactPerson.identityCardFileId = res.id.split('/')[0] + '/' + res.name;
                vm.identityCardFile = filename;
                vm.identityCardFileId = res.id;
                vm.identityCardFilePath = res.name;
                vm.icon_id_card = icon;
                vm.delete_id_card_file = delete_icon;
                vm.changedFieldIdentity = true;
            }
        };
    }

    init() {
        let vm = this;
        vm.user.organizationData.contactPerson.identityCardFile = vm.user.organizationData.contactPerson.identityCardFile === undefined ||
            vm.user.organizationData.contactPerson.identityCardFile === '' ?
            'Allega copia Carta Identita' : vm.user.organizationData.contactPerson.identityCardFile;

        vm.user.organizationData.contactPerson.fiscalCodeFile = vm.user.organizationData.contactPerson.fiscalCodeFile === undefined ||
            vm.user.organizationData.contactPerson.fiscalCodeFile === '' ?
            'Allega copia Codice Fiscale' : vm.user.organizationData.contactPerson.fiscalCodeFile;

        vm.user.organizationData.contactPerson.businessProfileFile = vm.user.organizationData.contactPerson.businessProfileFile === undefined ||
            vm.user.organizationData.contactPerson.businessProfileFile === '' ?
            'Allega copia Visura Camerale' : vm.user.organizationData.contactPerson.businessProfileFile;

        vm.identityCardFileBefore = vm.user.organizationData.contactPerson.identityCardFile;
        vm.fiscalCodeFileBefore = vm.user.organizationData.contactPerson.fiscalCodeFile;
        vm.businessProfileFileBefore = vm.user.organizationData.contactPerson.businessProfileFile;

        this.emptyFileVariable();

        vm.changedFieldFiscal = false;
        vm.changedFieldIdentity = false;
        vm.changedFieldBusinessProfile = false;
        vm.changedSuccess = false;
        vm.identityCardFileRequiredError = false;
    }

    emptyFileVariable() {
        let vm = this;
        vm.fiscalCodeFile = '';
        vm.fiscalCodeFileId = '';
        vm.fiscalCodeFilePath = '';
        vm.identityCardFile = '';
        vm.identityCardFileId = '';
        vm.identityCardFilePath = '';
        vm.businessProfileFile = '';
        vm.businessProfileFileId = '';
        vm.businessProfileFilePath = '';
    }

    ok() {
        this.$uibModalInstance.close();
    }

    cancel() {
        let vm = this;
        vm.user.organizationData.contactPerson.identityCardFile = vm.identityCardFileBefore === 'Allega copia Carta Identita' ? '' : vm.identityCardFileBefore;
        vm.user.organizationData.contactPerson.fiscalCodeFile = vm.fiscalCodeFileBefore === 'Allega copia Codice Fiscale' ? '' : vm.fiscalCodeFileBefore;
        vm.user.organizationData.contactPerson.businessProfileFile = vm.businessProfileFileBefore === 'Allega copia Visura Camerale' ? '' : vm.businessProfileFileBefore;
        vm.$uibModalInstance.dismiss('cancel');
    }
    save() {
        let vm = this;
        vm.identityCardFileRequiredError = vm.user.organizationData.contactPerson.identityCardFile === undefined ||
            vm.user.organizationData.contactPerson.identityCardFile === '' ||
            vm.user.organizationData.contactPerson.identityCardFile === 'Allega copia Carta Identita';

        let data = {
            'user': vm.user,
            'requiredFieldsMissing': vm.identityCardFileRequiredError
        };

        this.$uibModalInstance.close(data);
    }

    deleteFile($event: any) {
        let vm = this;
        let eventTarget = $event.currentTarget;

        if (eventTarget === undefined) {
            eventTarget = $event.target;
        }
        /* tslint:disable:no-string-literal */
        let dropzoneId = (eventTarget.closest('div.upload-file').querySelector('div[dropzone]')).attributes['dropzone'].value;

        if (dropzoneId === 'dropzone-fiscal-code') {
            vm.user.organizationData.contactPerson.fiscalCodeFileId = '';
            vm.user.organizationData.contactPerson.fiscalCodeFile = 'Allega copia Codice Fiscale';
            vm.fiscalCodeFile = '';
            vm.fiscalCodeFileId = '';
            vm.fiscalCodeFilePath = '';
            vm.icon_fiscal_code = '';
            vm.delete_fiscal_code = '';
            vm.changedFieldFiscal = false;
        } else if (dropzoneId === 'dropzone-business-profile') {
            vm.user.organizationData.contactPerson.businessProfileFileId = '';
            vm.user.organizationData.contactPerson.businessProfileFile = 'Allega copia Visura Camerale';
            vm.businessProfileFile = '';
            vm.businessProfileFileId = '';
            vm.businessProfileFilePath = '';
            vm.icon_business_profile = '';
            vm.delete_business_profile_file = '';
            vm.changedFieldBusinessProfile = false;
        } else {
            vm.user.organizationData.contactPerson.identityCardFileId = '';
            vm.user.organizationData.contactPerson.identityCardFile = 'Allega copia Carta Identita';
            vm.identityCardFile = '';
            vm.identityCardFileId = '';
            vm.identityCardFilePath = '';
            vm.icon_id_card = '';
            vm.delete_id_card_file = '';
            vm.changedFieldIdentity = false;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/add-person-files2.controller.ts